// extracted by mini-css-extract-plugin
module.exports = {"controlButtons":"styles-module__controlButtons___17RDv","controlButtonsSvg":"styles-module__controlButtonsSvg___3HAuM"};